import { PeriodTab } from './components/PeriodTab';
import { Container } from './styled';

type PeriodToggleProps = {
  yearlySelected: boolean;
  onToggle: (yearlySelected: boolean) => void;
};

// The bare Monthly/Annual segmented pill, reused by BillingPeriodTabs and the comparison table.
export const PeriodToggle = ({ yearlySelected, onToggle }: PeriodToggleProps) => (
  <Container aria-label="Billing period" role="group">
    <PeriodTab isActive={!yearlySelected} onSelect={() => onToggle(false)}>
      Monthly
    </PeriodTab>
    <PeriodTab isActive={yearlySelected} onSelect={() => onToggle(true)}>
      Annual
    </PeriodTab>
  </Container>
);
